var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tx-12 align-items-center d-flex bd-l"},[_vm._v(" asd ")])}
var staticRenderFns = []

export { render, staticRenderFns }